import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import tools from './tools'

import {
  NavbarPlugin, LayoutPlugin, CardPlugin, TooltipPlugin, InputGroupPlugin, FormInputPlugin,
  TableLitePlugin, ListGroupPlugin, ImagePlugin, ButtonGroupPlugin, ButtonPlugin,
  BIconCheck, BIconCheckSquare, BIconSquare
} from 'bootstrap-vue'

import './style.scss'
import i18n from './i18n'

import VueMeta from 'vue-meta'

Vue.use(VueMeta)

Vue.use(NavbarPlugin)
Vue.use(LayoutPlugin)
Vue.use(CardPlugin)
Vue.use(TooltipPlugin)
Vue.use(InputGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(TableLitePlugin)
Vue.use(ListGroupPlugin)
Vue.use(ImagePlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.component('BIconCheck', BIconCheck)
Vue.component('BIconCheckSquare', BIconCheckSquare)
Vue.component('BIconSquare', BIconSquare)

Vue.config.productionTip = false

new Vue({
  data: {
    tools: tools,
    categories: [
      ['power', [
        'drilling-screwdriving', 'sawing', 'grinding-polishing', 'sanding-planing-routing',
        'inflators-pumps-compressors', 'multi-tools', 'nailers-staplers', 'cleaning', 'lighting',
        'speciality', 'battery-charger']],
      ['garden', [
        'lawn-moving', 'grass-trimming', 'hedge-trimming', 'tree-cutting-pruning',
        'blowers-vacuums', 'garden-speciality', 'patio-cleaners']]
    ],
    countries: [
      'da-DK', 'de-DE', 'nl-NL', 'nn-NO', 'fi-FI', 'sv-SE', 'fr-FR', 'fr-BE',
      'en-AU', 'en-US', 'hu-HU', 'it-IT', 'pt-PT', 'es-ES', 'cs-CZ', 'pl-PL',
      'ru-RU', 'en-GB', 'de-CH', 'et-EE', 'lv-LV', 'lt-LT', 'ro-RO'
    ]
  },

  created () {
    i18n.locale = this.$store.state.currentLocale
  },

  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
